module.exports = __webpack_public_path__ + "static/img/gongzonghao.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gongzonghao.jpg
// module id = 165
// module chunks = 0